/**
 * Customer GDAP configuration types matching HaloPSA custom fields.
 * See Appendix A of the unified project plan for field definitions.
 */
export const ACCESS_TYPES = ["OPEN", "LOCKED", "TEAMS"];
export const SERVICE_TIERS = [
    "Enterprise",
    "Premium",
    "Standard",
    "Essential",
    "Monitoring",
];
export const TIER_REQUIREMENTS = [
    "None",
    "Tier-0-Only",
    "Tier-1-Plus",
    "Tier-2-Plus",
    "Tier-3-Plus",
    "Tier-4-Plus",
];
export const CLEARANCE_LEVELS = ["None", "Basic", "NV1", "NV2", "PV"];
export const LOCATION_REQUIREMENTS = ["None", "AU", "NZ", "SG", "AU+NZ", "APAC"];
export const MAX_ACCESS_LEVELS = [
    "FullAccess",
    "StandardAccess",
    "LimitedAccess",
    "ReadOnly",
];
export const REVIEW_FREQUENCIES = ["Monthly", "Quarterly", "Annually"];
/**
 * Hierarchy ordering for clearance levels, from lowest (0) to highest (4).
 */
export const CLEARANCE_HIERARCHY = {
    None: 0,
    Basic: 1,
    NV1: 2,
    NV2: 3,
    PV: 4,
};
/**
 * Hierarchy ordering for tier requirements.
 * Lower number = more restrictive. Tier-0-Only is the most restrictive.
 */
export const TIER_HIERARCHY = {
    "Tier-4-Plus": 5,
    "Tier-3-Plus": 4,
    "Tier-2-Plus": 3,
    "Tier-1-Plus": 2,
    "Tier-0-Only": 1,
    None: 0,
};
/**
 * Whether a customer has Teams Specialist access enabled.
 * accessType "TEAMS" implies Teams is enabled — the teamsEnabled boolean is irrelevant.
 */
export function isTeamsEnabled(customer) {
    return customer.accessType === "TEAMS" || customer.teamsEnabled;
}
//# sourceMappingURL=customer.js.map